import { Tag } from 'src/services/tag/Tag';

export function hasChildren<T extends Tag>(tags: T[], tag: T) {
  return tags.some(
    (t) => t.fullPath.startsWith(tag.fullPath) && t.fullPath !== tag.fullPath
  );
}
